import CompanyProducts from './company-products';
export default CompanyProducts;